<template>
	<div class="detailBody">
		<a-breadcrumb>
			<a-breadcrumb-item>订单管理</a-breadcrumb-item>
		    <a-breadcrumb-item>退款申请处理</a-breadcrumb-item>
		    <a-breadcrumb-item>退款详情</a-breadcrumb-item>
		</a-breadcrumb>
		<a-card class="orderCard" :headStyle="{color:'red',background:'#F2F6FC',padding: '20px 0px 20px 20px'}">
			<p style="fontSize: 16px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
				<a-icon type="book" /> 退货商品
			</p>
			<a-table :columns="commityColumns" :data-source="commityData" :pagination="false" bordered>
				<template slot="specificationPic" slot-scope="text">
					<img style="width: 100px;" :src="text" alt="">
				</template>
			</a-table>
		</a-card>
		<a-card class="orderCard" :headStyle="{color:'red',background:'#F2F6FC',padding: '20px 0px 20px 20px'}">
			<p style="fontSize: 16px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
				<a-icon type="book" /> 服务单信息
			</p>
			<table class="border_table" style="width: 100%;">
				<tr class="border_table">
					<td class="border_table border_table_td">服务单号</td>
					<td class="border_table border_table_td2">{{commityData[0].refundSn}}</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">申请状态</td>
					<td class="border_table border_table_td2" style="color: red;font-weight: bold;" v-if="commityData[0].refundStatus == 0" color='cyan'>待处理</td>
					<td class="border_table border_table_td2" style="color: red;font-weight: bold;" v-if="commityData[0].refundStatus == 1" color='green'>退款成功</td>
					<td class="border_table border_table_td2" v-if="commityData[0].refundStatus == 2" color='red'>拒绝退款</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">订单编号</td>
					<td class="border_table border_table_td2">{{commityData[0].orderSn}}</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">申请时间</td>
					<td class="border_table border_table_td2">{{commityData[0].addTime}}</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">用户账号</td>
					<td class="border_table border_table_td2">{{commityData[0].phone}}</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">联系人</td>
					<td class="border_table border_table_td2">{{commityData[0].nickName}}</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">联系电话</td>
					<td class="border_table border_table_td2" style="color: royalblue;font-weight: bold;" >{{commityData[0].tel}}</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">退货原因</td>
					<td class="border_table border_table_td2">{{commityData[0].refundCause}}</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">问题描述</td>
					<td class="border_table border_table_td2">{{commityData[0].refundExplain}}</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">凭证图片</td>
					<td class="border_table border_table_td2">
						<span :key="index" v-for="(item,index) in commityData[0].img">
							<img style="width: 100px;" :src="item" alt="">
						</span>
					</td>
				</tr>
			</table>
			<table class="border_table" style="width: 100%;margin-top: 30px;">
				<tr class="border_table">
					<td class="border_table border_table_td">订单金额</td>
					<td class="border_table border_table_td2" style="color: red;font-weight: bold;" >{{commityData[0].bazaarPrice}}</td>
				</tr>
				<!-- <tr class="border_table">
					<td class="border_table border_table_td">确认退款金额（元）</td>
					<td class="border_table border_table_td2">
						<a-form-model-item  label="">
							<a-input style="width: 200px;margin-top: 20px;" v-model="refundMoney" />
						</a-form-model-item>
					</td>
				</tr>
				<tr class="border_table">
					<td class="border_table border_table_td">商家收货地点</td>
					<td class="border_table border_table_td2">
						<a-form-model-item  label="">
							<a-input style="width: 200px;margin-top: 20px;" v-model="shippingAddress" />
						</a-form-model-item>
					</td>
				</tr> -->
				<tr class="border_table">
					<td class="border_table border_table_td">处理备注</td>
					<td class="border_table border_table_td2">
						<a-form-model-item  label="">
							<a-input style="width: 200px;margin-top: 20px;" v-model="remark" />
						</a-form-model-item>
					</td>
				</tr>
			</table>
			<div style="text-align: center;margin-top: 20px;">
				<a-button v-if="commityData[0].refundStatus == 0" type="primary" @click="affirmRefundOrder">
					确认退款
				</a-button>	
				<!-- <a-button style="margin-left: 10px;" type="danger">
					拒绝退款
				</a-button> -->
			</div>
			<div style="text-align: center;margin-top: 40px;">
				
			</div>
		</a-card>
	</div>
</template>

<script>
	const commityColumns = [
	  {
	    dataIndex: 'specificationPic',
	    key: 'specificationPic',
	    title: '商品图片',
	    scopedSlots: { customRender: 'specificationPic' },
	  },
	  {
	    title: '商品名称',
	    dataIndex: 'productName',
	    key: 'productName',
	  },
	  {
	    title: '价格',
	    dataIndex: 'bazaarPrice',
	    key: 'bazaarPrice',
	  },
	  {
	    title: '规格',
	    key: 'specification',
	    dataIndex: 'specification',
	  },
	  {
	    title: '数量',
	    key: 'productAmount',
	    dataIndex: 'productAmount',
	  },
	  {
	    title: '小计',
	    key: 'refundMoney',
		dataIndex: 'refundMoney'
	  },
	];
	
	import api from '../../../api/Api.js';
export default {
	data() {
		return {
			commityData :[],
			commityColumns,
			refundMoney:0,
			remark:'',
			shippingAddress:'',
			refundId : this.$route.query.id
		};
	},
	mounted() {
		this.getOrderDetailInfo();
	},
	methods: {
		getOrderDetailInfo(){
			const that = this;
			let url = 'api/store/v1/admin/order/refundOrderDetail';
			let parm = {
				refundId: that.refundId
			};
			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					that.commityData = [];
					const order = res.data.data;
					order.key = '1';
					order.refundMoney = this.formatMoney(order.refundMoney);
					order.bazaarPrice = this.formatMoney(order.bazaarPrice);
					
					that.commityData.push(order);
					console.log(order)
					
					
				} else if (res.data.status == 501) {
					this.$message.error(res.message);
				} else {
					this.$message.error(res.message);
				}
			});
		},
		affirmRefundOrder(){
			
			const that = this;
			let url = 'api/store/v1/admin/order/affirmRefundOrder';
			let parm = {
				refundId: that.refundId,
				remark: that.remark
			};
			
			this.$confirm({
				title: '确定退款吗？',
				content: '退款后，将退还该订单金额，订单金额将会在7个自然日后返回到用户账户',
				onOk() {
					api.postRequest(url, parm, res => {
						if (res.data.status == 200) {
							that.$message.success("已确认退款，将会在7个自然日后返回到用户账户！")
							this.getOrderDetailInfo();
						} else if (res.data.status == 501) {
							that.$message.error(res.message);
						} else {
							that.$message.error(res.message);
						}
					});
				},
				onCancel() {
					that.$message.warning('你点击了取消');
				}
			});
		},
		formatMoney(money){
			money += '';
			var arr = money.split('');
			var money = '';
			for (var i = 0; i < arr.length; i++) {
				money += arr[i];
				if (i == arr.length - 3) {
					money += '.';
				}
			}
			return "￥"+money;
		}
	}
};
</script>

<style scoped>
	
	.detailBody{
		padding-left: 20%;
		padding-right: 20%;
		padding-top: 5%;
	}

	.orderCard{
		margin-top: 40px;
		margin-bottom: 40px;
	}
	
	.border_table{
		border: 1px solid #dcdfe6;
		font-size: 16px;
	}
	.border_table_td{
		width: 25%;
		height: 40px;
		padding-left: 10px;
		background: #F2F6FC;
	}
	
	.border_table_td2{
		padding-left: 20px;
	}
	
	th.column-money,
	td.column-money {
	  text-align: right !important;
	}
	.ant-table-thead > tr > th{
		background: #F2F6FC;
	}
	.orderStatusTag{
		font-size: 18px;
	}
	
	
</style>
